const areas = [
  'Henry County, GA',
  'Stockbridge, GA',
  'McDonough, GA',
  'Hampton, GA',
  'Locust Grove, GA',
  'Lovejoy, GA',
  'Jonesboro, GA',
  'Metro Atlanta, GA',
];

export default function ServiceAreas() {
  return (
    <section className="py-24 bg-stone-950 relative overflow-hidden">
      {/* Map background */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/c224d4b33c036af85a3f733b61acb010.jpg"
          alt="Service area map"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-stone-950/90 via-stone-950/70 to-stone-950/90" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-px bg-amber-600" />
              <span className="text-amber-500 text-xs font-semibold tracking-[0.2em] uppercase">
                Where We Work
              </span>
            </div>
            <h2
              className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Serving Henry County
              <br />
              <span className="text-amber-500">&amp; Metro Atlanta</span>
            </h2>
            <p className="text-stone-400 text-base leading-relaxed mb-8">
              Based in Stockbridge, GA, Fletcher &amp; Cooley serves commercial clients throughout Henry County and the greater Metro Atlanta area. Our local presence means faster permitting, better subcontractor relationships, and a team that knows your market.
            </p>
            <p className="text-stone-400 text-base leading-relaxed mb-10">
              Additional service areas in Metro Atlanta are available upon request. Contact us to confirm availability for your specific location.
            </p>
            <a
              href="#contact"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-amber-700 hover:bg-amber-600 text-white font-semibold text-sm px-8 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-map-pin-line text-sm" />
              </span>
              Check Your Area
            </a>
          </div>

          {/* Right: Area tags */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-10">
            <div className="flex items-center gap-2 mb-6">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-pin-2-fill text-amber-500 text-base" />
              </span>
              <span className="text-white font-semibold text-base">Primary Service Areas</span>
            </div>
            <div className="flex flex-wrap gap-3 mb-8">
              {areas.map((area) => (
                <span
                  key={area}
                  className="bg-white/10 border border-white/20 text-white text-sm px-4 py-2 rounded-full"
                >
                  {area}
                </span>
              ))}
            </div>
            <div className="border-t border-white/10 pt-6">
              <p className="text-stone-400 text-sm leading-relaxed">
                <strong className="text-white">Headquarters:</strong> Stockbridge, GA 30281
                <br />
                <strong className="text-white">Phone:</strong>{' '}
                <a href="tel:6783948805" className="text-amber-400 hover:text-amber-300 cursor-pointer">
                  (678) 394-8805
                </a>
                <br />
                <strong className="text-white">Coverage:</strong> Henry County &amp; Metro Atlanta
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
